import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { translations } from '../../../utils/translations/translations-manager';

export function ComingSoon(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center">
      <CalendarDaysIcon className='h-10 w-10' />
      <h1 className="text-3xl font-bold text-gray-800 mb-4">{translations.texts.coming_soon.toString()}!</h1>
    </div>
  );
};

export default ComingSoon;